import { render, staticRenderFns } from "./RootContainer.vue?vue&type=template&id=7066a504&"
import script from "./RootContainer.vue?vue&type=script&lang=js&"
export * from "./RootContainer.vue?vue&type=script&lang=js&"
import style0 from "./RootContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports